export default "/images/37a781dac1372c9e7a1761a0ed6fd3cf.avif";